import React, { useState } from "react";
import {
  Popover,
  Icon,
  CheckboxGroup,
  Checkbox,
  Button,
} from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import StyledChip from "../../../../../components/styled/Chip";
import { useEffect } from "react";
import cloneDeep from "lodash/cloneDeep";
import { TPD_COLUMNS } from "../../../EmpulsReport/constants";

const StyledRenderCheckBoxListContainer = styled.div.attrs()`
  max-height: 300px;
  overflow-y: scroll;
`;

const StyledCheckboxGroup = styled(CheckboxGroup).attrs()`
  input[type="checkbox"]:disabled ~ .eui-checkbox-icon {
    background: ${(props) => props.theme.palette.dark.c000};
    border-color: ${(props) => props.theme.palette.dark.c000};
  }
  label {
    position: relative;
  }
`;

const Column = ({
  columns: initialColumns,
  setColumns: initialSetColumns,
  chipProps,
  hideReportOptions,
  tpdCustomColumns
}) => {
  const [selected, setSelected] = useState(false);
  const [columns, setColumns] = useState([]);

  const handleSelectAll = () => {
    let newColumns = [...columns];
    newColumns = newColumns.map((column) => {
      if (column.defaultChecked) {
        column.checked = true;
        return column;
      } else {
        if (column.options) {
          column.options["display"] = false;
        } else {
          column = { ...column, options: { display: false } };
        }
      }
      return column;
    });
    setColumns(newColumns);
  };
  const handleChange = (e, filterData) => {
    filterData.options = filterData?.options || {};
    filterData.options.display =
      filterData.options.display === false ? true : false;
    const filterColumnData = columns.map((item) => {
      if (item.label == filterData.label) {
        item = filterData;
        return item;
      }
      return item;
    });
    setColumns(filterColumnData);
  };

  const renderCheckBoxList = () => (
    <StyledCheckboxGroup direction="column" className="p-12">
      {columns.map((item, index) => {
        if (item && !(item.label === " " || item.name === "action")) {
          return (
            <Checkbox
              key={index}
              label={item.label}
              checked={item?.options?.display === false ? false : true}
              disabled={item.defaultChecked}
              onChange={(e) => {
                handleChange(e, item);
              }}
            />
          );
        }
      })}
    </StyledCheckboxGroup>
  );

  const disableRestoreDefaultBtn = () => {
    let onlyDefaultSelected = true;

    columns.map((column) => {
      if (
        !(column?.options?.display === false) &&
        column?.defaultChecked !== true
      ) {
        onlyDefaultSelected = false;
      }
    });
    return onlyDefaultSelected;
  };

  const isDisabled = hideReportOptions;

  useEffect(() => {
    setColumns(cloneDeep(initialColumns));
  }, [initialColumns]);


  useEffect(() => {
    const newColumns = cloneDeep(initialColumns);
    if (tpdCustomColumns.length > 0) {
      tpdCustomColumns.map(column => {
        newColumns.splice(newColumns.length - 1, 0, {
          name: column,
          label: column,
          defaultChecked: false,
          options: { display: false }
        })
      })
    }
    setColumns(newColumns);
  }, [tpdCustomColumns]);


  let isChangesMade = false;
  let isAllColumnsSelected = true;
  for (let i = 0; i < columns.length; i++) {
    if (columns[i]?.options?.display === false) {
      isAllColumnsSelected = false;
    }
    if (columns[i]?.options?.display !== initialColumns[i]?.options?.display) {
      isChangesMade = true;
    }
  }

  return (
    <div>
      <Popover
        width={isDisabled ? 0 : 252}
        zIndex={1000}
        onVisibilityChange={(data) => {
          setSelected(data);
        }}
        content={
          isDisabled ? null : (
            <div className="">
              <Checkbox
                label="Select All"
                className="mt-10 ml-12 mb-10"
                checked={isAllColumnsSelected}
                onChange={() => {
                  const newColumns = columns.map((item) => {
                    item.options = item?.options || {};
                    if (!item.defaultChecked) {
                      item.options.display = isAllColumnsSelected
                        ? false
                        : true;
                    }
                    return item;
                  });
                  setColumns(newColumns);
                }}
              />
              <hr className="m-0" />
              <StyledRenderCheckBoxListContainer>
                {renderCheckBoxList()}
              </StyledRenderCheckBoxListContainer>
              <hr className="m-0" />
              <div className="text-right">
                <Button
                  className="mt-12 mr-8 mb-16"
                  size="small"
                  variant="outlined"
                  disabled={!isChangesMade}
                  onClick={() => {
                    document.body.click();
                    initialSetColumns(columns);
                  }}
                >
                  Apply Changes
                </Button>
              </div>
            </div>
          )
        }
        offset={[0, 16]}
        placement="bottom-end"
      >
        <StyledChip
          {...chipProps[selected ? "active" : "unactive"]}
          textColor="dark"
          textShade="c300"
          label="Columns"
          size="medium"
          className="ml-12 pl-8"
          disabled={isDisabled}
          id="reports-column-btn"
          avatar={
            <div className="pl-2">
              <Icon iconName="PlumColumns" className="mt-6" size={16} />
            </div>
          }
        />
      </Popover>
    </div>
  );
};

export default Column;
